import { showErrorModal } from './modal';

export const getBody = (resp, ...extraStatuses) => {
    return statusOk(resp, extraStatuses)
        ? resp.json()
        : resp.text().then(text => Promise.reject(text));
};

export const statusOk = (resp, ...extraStatuses) => {
    return resp.ok || extraStatuses.includes(resp.status);
}

export const displayError = reason => dispatch => {
    return dispatch(showErrorModal(`${reason}`));
};

export const generateReprocessingDialogText = (results, thing) => {
    let message = `Queued ${results.length} ${thing} for reprocessing.`;

    let errors = results.filter(val => val !== '' && typeof val === 'string');
    if (errors.length) {
        message += `\n\nThere were errors submitting reprocessing:\n○ ${results.join('\n\n○ ')}`;
    }

    return message;
};



// WEBPACK FOOTER //
// ./src/actions/helpers.js